module.exports = __webpack_public_path__ + "static/media/ramesh.f3fce6db.png";